// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.clip-share-sheet {
  position: fixed;
  inset: 0;
  z-index: 13000;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: max(12px, env(safe-area-inset-bottom, 0px)) 12px 12px;
  background: rgba(8, 10, 16, 0.62);
  backdrop-filter: blur(10px);
}

.clip-share-sheet__panel {
  width: min(440px, 100%);
  max-height: min(88vh, 760px);
  overflow: auto;
  padding: 10px 18px 22px;
  border-radius: 22px 22px 18px 18px;
  background: linear-gradient(180deg, rgba(24, 28, 38, 0.96) 0%, #12151d 100%);
  border: 1px solid rgba(255, 255, 255, 0.08);
  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.45);
  color: #f4f6fb;
}

.clip-share-sheet__handle {
  width: 42px;
  height: 4px;
  margin: 4px auto 12px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.22);
}

.clip-share-sheet__header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 14px;
}

.clip-share-sheet__header h2 {
  margin: 0 0 4px;
  font-size: 1.12rem;
  font-weight: 750;
  letter-spacing: -0.02em;
}

.clip-share-sheet__header p {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.45;
  color: rgba(244, 246, 251, 0.68);
}

.clip-share-sheet__close {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
  font-size: 1.4rem;
  line-height: 1;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), background 0.2s ease;
}

.clip-share-sheet__close:hover {
  background: rgba(255, 255, 255, 0.14);
}

.clip-share-sheet__close:active {
  transform: scale(0.96);
}

.clip-share-sheet__preview {
  width: 132px;
  aspect-ratio: 9 / 16;
  margin: 0 auto 18px;
  overflow: hidden;
  border-radius: 14px;
  background: #000;
  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);
}

.clip-share-sheet__preview video,
.clip-share-sheet__preview-empty {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.clip-share-sheet__preview-empty {
  display: grid;
  place-items: center;
  padding: 12px;
  text-align: center;
  font-size: 0.72rem;
  color: rgba(255, 255, 255, 0.7);
}

.clip-share-sheet__grid {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px 8px;
  margin-bottom: 14px;
}

.clip-share-sheet__dest {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  padding: 6px 4px;
  border: none;
  background: transparent;
  color: rgba(244, 246, 251, 0.92);
  font: inherit;
  font-size: 0.72rem;
  font-weight: 650;
  cursor: pointer;
  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);
}

.clip-share-sheet__dest:hover:not(:disabled) .clip-share-sheet__icon {
  transform: scale(1.06);
}

.clip-share-sheet__dest:active:not(:disabled) {
  transform: scale(0.97);
}

.clip-share-sheet__dest:disabled {
  opacity: 0.55;
  cursor: wait;
}

.clip-share-sheet__icon {
  display: grid;
  place-items: center;
  width: 54px;
  height: 54px;
  border-radius: 16px;
  color: #fff;
  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);
}

.clip-share-sheet__icon svg {
  width: 26px;
  height: 26px;
}

.clip-share-sheet__dest--instagram .clip-share-sheet__icon {
  background: linear-gradient(135deg, #f58529, #dd2a7b 52%, #8134af);
}

.clip-share-sheet__dest--tiktok .clip-share-sheet__icon {
  background: #111;
  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);
  color: #fff;
}

.clip-share-sheet__dest--whatsapp .clip-share-sheet__icon {
  background: #25d366;
}

.clip-share-sheet__dest--facebook .clip-share-sheet__icon {
  background: #1877f2;
}

.clip-share-sheet__dest--more .clip-share-sheet__icon {
  background: rgba(255, 255, 255, 0.12);
}

.clip-share-sheet__dest--download .clip-share-sheet__icon {
  background: linear-gradient(180deg, #3b82f6, #1d4ed8);
}

.clip-share-sheet__hint,
.clip-share-sheet__status,
.clip-share-sheet__error {
  margin: 0;
  font-size: 0.76rem;
  line-height: 1.45;
}

.clip-share-sheet__hint {
  color: rgba(244, 246, 251, 0.58);
}

.clip-share-sheet__status {
  margin-top: 10px;
  color: #86efac;
}

.clip-share-sheet__error {
  margin-top: 10px;
  color: #fca5a5;
}

@media (min-width: 720px) {
  .clip-share-sheet {
    align-items: center;
    padding: 24px;
  }

  .clip-share-sheet__panel {
    border-radius: 20px;
  }

  .clip-share-sheet__handle {
    display: none;
  }
}

.clip-share-sheet__close:focus-visible,
.clip-share-sheet__dest:focus-visible {
  outline: 2px solid #7dd3fc;
  outline-offset: 3px;
}
`, "",{"version":3,"sources":["webpack://./src/components/social/ClipShareSheet.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,cAAc;EACd,aAAa;EACb,qBAAqB;EACrB,uBAAuB;EACvB,8DAA8D;EAC9D,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,uBAAuB;EACvB,4BAA4B;EAC5B,cAAc;EACd,uBAAuB;EACvB,kCAAkC;EAClC,4EAA4E;EAC5E,2CAA2C;EAC3C,2CAA2C;EAC3C,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,qBAAqB;EACrB,oBAAoB;EACpB,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,qCAAqC;EACrC,WAAW;EACX,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,8EAA8E;AAChF;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;AAC7C;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,YAAY;EACZ,uBAAuB;EACvB,gCAAgC;EAChC,aAAa;EACb,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,wDAAwD;AAC1D;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,WAAW;EACX,yDAAyD;AAC3D;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,kEAAkE;AACpE;;AAEA;EACE,gBAAgB;EAChB,qDAAqD;EACrD,WAAW;AACb;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,qDAAqD;AACvD;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE;IACE,mBAAmB;IACnB,aAAa;EACf;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,aAAa;EACf;AACF;;AAEA;;EAEE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".clip-share-sheet {\n  position: fixed;\n  inset: 0;\n  z-index: 13000;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  padding: max(12px, env(safe-area-inset-bottom, 0px)) 12px 12px;\n  background: rgba(8, 10, 16, 0.62);\n  backdrop-filter: blur(10px);\n}\n\n.clip-share-sheet__panel {\n  width: min(440px, 100%);\n  max-height: min(88vh, 760px);\n  overflow: auto;\n  padding: 10px 18px 22px;\n  border-radius: 22px 22px 18px 18px;\n  background: linear-gradient(180deg, rgba(24, 28, 38, 0.96) 0%, #12151d 100%);\n  border: 1px solid rgba(255, 255, 255, 0.08);\n  box-shadow: 0 24px 70px rgba(0, 0, 0, 0.45);\n  color: #f4f6fb;\n}\n\n.clip-share-sheet__handle {\n  width: 42px;\n  height: 4px;\n  margin: 4px auto 12px;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.22);\n}\n\n.clip-share-sheet__header {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 12px;\n  margin-bottom: 14px;\n}\n\n.clip-share-sheet__header h2 {\n  margin: 0 0 4px;\n  font-size: 1.12rem;\n  font-weight: 750;\n  letter-spacing: -0.02em;\n}\n\n.clip-share-sheet__header p {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.45;\n  color: rgba(244, 246, 251, 0.68);\n}\n\n.clip-share-sheet__close {\n  flex-shrink: 0;\n  width: 36px;\n  height: 36px;\n  border: none;\n  border-radius: 50%;\n  background: rgba(255, 255, 255, 0.08);\n  color: #fff;\n  font-size: 1.4rem;\n  line-height: 1;\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1), background 0.2s ease;\n}\n\n.clip-share-sheet__close:hover {\n  background: rgba(255, 255, 255, 0.14);\n}\n\n.clip-share-sheet__close:active {\n  transform: scale(0.96);\n}\n\n.clip-share-sheet__preview {\n  width: 132px;\n  aspect-ratio: 9 / 16;\n  margin: 0 auto 18px;\n  overflow: hidden;\n  border-radius: 14px;\n  background: #000;\n  box-shadow: 0 12px 28px rgba(0, 0, 0, 0.35);\n}\n\n.clip-share-sheet__preview video,\n.clip-share-sheet__preview-empty {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  display: block;\n}\n\n.clip-share-sheet__preview-empty {\n  display: grid;\n  place-items: center;\n  padding: 12px;\n  text-align: center;\n  font-size: 0.72rem;\n  color: rgba(255, 255, 255, 0.7);\n}\n\n.clip-share-sheet__grid {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 12px 8px;\n  margin-bottom: 14px;\n}\n\n.clip-share-sheet__dest {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 8px;\n  padding: 6px 4px;\n  border: none;\n  background: transparent;\n  color: rgba(244, 246, 251, 0.92);\n  font: inherit;\n  font-size: 0.72rem;\n  font-weight: 650;\n  cursor: pointer;\n  transition: transform 0.2s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.clip-share-sheet__dest:hover:not(:disabled) .clip-share-sheet__icon {\n  transform: scale(1.06);\n}\n\n.clip-share-sheet__dest:active:not(:disabled) {\n  transform: scale(0.97);\n}\n\n.clip-share-sheet__dest:disabled {\n  opacity: 0.55;\n  cursor: wait;\n}\n\n.clip-share-sheet__icon {\n  display: grid;\n  place-items: center;\n  width: 54px;\n  height: 54px;\n  border-radius: 16px;\n  color: #fff;\n  transition: transform 0.25s cubic-bezier(0.16, 1, 0.3, 1);\n}\n\n.clip-share-sheet__icon svg {\n  width: 26px;\n  height: 26px;\n}\n\n.clip-share-sheet__dest--instagram .clip-share-sheet__icon {\n  background: linear-gradient(135deg, #f58529, #dd2a7b 52%, #8134af);\n}\n\n.clip-share-sheet__dest--tiktok .clip-share-sheet__icon {\n  background: #111;\n  box-shadow: inset 0 0 0 1px rgba(255, 255, 255, 0.12);\n  color: #fff;\n}\n\n.clip-share-sheet__dest--whatsapp .clip-share-sheet__icon {\n  background: #25d366;\n}\n\n.clip-share-sheet__dest--facebook .clip-share-sheet__icon {\n  background: #1877f2;\n}\n\n.clip-share-sheet__dest--more .clip-share-sheet__icon {\n  background: rgba(255, 255, 255, 0.12);\n}\n\n.clip-share-sheet__dest--download .clip-share-sheet__icon {\n  background: linear-gradient(180deg, #3b82f6, #1d4ed8);\n}\n\n.clip-share-sheet__hint,\n.clip-share-sheet__status,\n.clip-share-sheet__error {\n  margin: 0;\n  font-size: 0.76rem;\n  line-height: 1.45;\n}\n\n.clip-share-sheet__hint {\n  color: rgba(244, 246, 251, 0.58);\n}\n\n.clip-share-sheet__status {\n  margin-top: 10px;\n  color: #86efac;\n}\n\n.clip-share-sheet__error {\n  margin-top: 10px;\n  color: #fca5a5;\n}\n\n@media (min-width: 720px) {\n  .clip-share-sheet {\n    align-items: center;\n    padding: 24px;\n  }\n\n  .clip-share-sheet__panel {\n    border-radius: 20px;\n  }\n\n  .clip-share-sheet__handle {\n    display: none;\n  }\n}\n\n.clip-share-sheet__close:focus-visible,\n.clip-share-sheet__dest:focus-visible {\n  outline: 2px solid #7dd3fc;\n  outline-offset: 3px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
